import { useState, useEffect } from 'react';
import { fetchAuthSession } from '@aws-amplify/auth';
import { hasFullConfiguratorAccess } from '../config/vendorRegistry';
import { log } from '../utils/devLog';

export const useUserPermissions = (user) => {
  const [permissions, setPermissions] = useState({
    userGroups: [],
    hasSpecialAccess: false,
    hasFullConfigurator: false,
    canToggleConsultation: false,
    hasAdminAccess: false,
    hasExecAccess: false,
    hasDualCpuAccess: false,
    isCheckingAccess: true,
    licenseCheckComplete: false
  });

  useEffect(() => {
    const checkAllPermissions = async () => {
      if (!user) {
        setPermissions({
          userGroups: [],
          hasSpecialAccess: false,
          hasFullConfigurator: false,
          canToggleConsultation: false,
          hasAdminAccess: false,
          hasExecAccess: false,
          hasDualCpuAccess: false,
          isCheckingAccess: false,
          licenseCheckComplete: true
        });
        return;
      }

      try {
        const session = await fetchAuthSession();
        const groups = session.tokens?.accessToken?.payload['cognito:groups'] || [];

        const hasSpecialAccess = groups.includes('specialPricing');
        // Single definition of "full configurator user", shared with the vendor
        // registry. It gates consultation/pricing depth only — WHICH hardware a
        // user sees is the per-vendor groups, resolved by
        // vendorRegistry.getAccessibleVendors(userGroups); there is no
        // per-vendor flag here on purpose.
        const hasFullConfigurator = hasFullConfiguratorAccess(groups);
        const hasAdminAccess = groups.includes('adminAccess');
        const hasExecAccess = groups.includes('execAccess');
        // CONF-259: Dual CPU flash is its own group, independent of execAccess.
        const hasDualCpuAccess = groups.includes('dualCpuAccess');

        log('👥 User Groups:', groups);
        log('✅ Special Access:', hasSpecialAccess);

        setPermissions({
          userGroups: groups,
          hasSpecialAccess,
          hasFullConfigurator,
          canToggleConsultation: hasFullConfigurator,
          hasAdminAccess,
          hasExecAccess,
          hasDualCpuAccess,
          isCheckingAccess: false,
          licenseCheckComplete: true
        });
      } catch (error) {
        console.error('Error checking user permissions:', error);
        setPermissions({
          userGroups: [],
          hasSpecialAccess: false,
          hasFullConfigurator: false,
          canToggleConsultation: false,
          hasAdminAccess: false,
          hasExecAccess: false,
          hasDualCpuAccess: false,
          isCheckingAccess: false,
          licenseCheckComplete: true
        });
      }
    };

    checkAllPermissions();
  }, [user?.username]); // Only re-run if user changes

  return permissions;
};